import { motion, useScroll, useSpring, useReducedMotion } from "framer-motion";

export default function ScrollProgress() {
  const reduce = useReducedMotion();
  const { scrollYProgress } = useScroll();
  const scaleX = useSpring(scrollYProgress, { stiffness: 120, damping: 30, mass: 0.3 });
  if (reduce) return null;
  return (
    <motion.div
      aria-hidden="true"
      className="fixed top-0 inset-x-0 z-[60] h-[2.5px] origin-left bg-gradient-to-r from-cy via-[#7dd0e0] to-ember pointer-events-none"
      style={{ scaleX }}
      data-testid="scroll-progress"
    />
  );
}
